import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import NoticeForm from '@shared/NoticeForm'

const Content = ({ user }) => {
  const navigate = useNavigate()

  const handleSave = () => {
    navigate('/settings/notices-and-release-notes#notices')

    Swal.fire({
      text: 'Notice added!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })
  }

  return (
    <Fragment>

      <Title text='New Notice' user={user} />

      <NoticeForm
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const NewNotice = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default NewNotice
